var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creation-date-cell"},[_c('div',{staticClass:"creation-date-cell__date",class:{invalid: !_vm.isValidDate}},[_c('div',{staticClass:"creation-date-cell__date__container"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }